import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper'

// STATE

interface State {}

const state: State = {}


// GETTERS

interface Getters {}

const getters: DefineGetters<Getters, State> = {}


// MUTATIONS

interface Mutations {}

const mutations: DefineMutations<Mutations, State> = {}


// ACTIONS

interface Actions {}

const actions: DefineActions<Actions, State, Mutations, Getters> = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
